import './css/main.scss'; // главный SCSS
import './js/script.js'; // основной скрипт

// Импорт всех необходимых скриптов
import './mixins/tc-tips/tc-tips.scss';
import './mixins/tc-tips/tc-tips.js';

// Кнопка "Вверх"
import './mixins/scroll-button/scroll-button.scss';
import './mixins/scroll-button/scroll-button.js';

// Фильтр товаров
import './mixins/filter/slider.scss';
import './mixins/filter/slider.js';
import './mixins/filter/index.scss';
import './mixins/filter/index.js';

// Примерка
import './mixins/fitting/fitting.scss';
import './mixins/fitting/fitting-init.js';

// Политика обработки персональных данных
import './mixins/tc-privacy-policy/tc-privacy-policy.scss';
import './mixins/tc-privacy-policy/tc-privacy-policy.js';

// Форма оплаты частями
import './mixins/installment/installment.scss';
import './mixins/installment/installment.js';

// SEO текст для каталога
import './mixins/seoText/seoText.scss';
import './mixins/seoText/seoText.js';

// Видео плеер
import './mixins/videoPlayer/videoPlayer.scss';
import './mixins/videoPlayer/videoPlayer.js';

// Остальные миксины
import './mixins/banners/banners.scss';
import './mixins/banners-carousel/banners-carousel.js';
import './mixins/banners-carousel/banners-carousel.scss';
import './mixins/brand-categories/brand-categories.scss';
import './mixins/brands/brands.scss';
import './mixins/brands/brands.js';
import './mixins/catalog-banner/catalog-banner.scss';
import './mixins/catalog-banners/catalog-banners.scss';
import './mixins/gift/gift.scss';
import './mixins/not-offer/not-offer.scss';
import './mixins/product-card/product-card.scss';
import './mixins/properties/properties.scss';
import './mixins/roundIconButtons/roundIconButtons.scss';
import './mixins/stickers/stickers.scss';
import './mixins/tc-button/tc-button.scss';
import './mixins/tc-other-models/tc-other-models.js';
import './mixins/tc-other-models/tc-other-models.scss';


// Splide
//import './mixins/tc-big-slider/tc-big-slider.js';
import './mixins/tc-big-slider/tc-big-slider_video.js';
import './mixins/tc-big-slider/tc-big-slider.scss';
